import React, { useState } from 'react'
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  MenuItem
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { addToPipelineAndHide, markHidden } from 'store/actions/pipeline'

const LS_HIDE = 'dontShowCheckedHide'

const HideDialog = ({ handleSubmit, handleClose }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const [skipNextTime, setSkipNextTime] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Dialog className="Profile-gift-analysis-dialog" open={true} onClose={handleClose}>
      <DialogTitle>{t.cards.hideTitle}</DialogTitle>
      <DialogContent>
        <p>{t.cards.hideConfirm}</p>
        <FormControlLabel
          control={
            <Checkbox checked={skipNextTime} onCheck={() => setSkipNextTime(!skipNextTime)} />
          }
          label={t.cards.noShow}
        />
      </DialogContent>
      <DialogActions>
        {!isLoading && (
          <Button onClick={handleClose} disabled={isLoading} variant="text">
            {t.global.cancel}
          </Button>
        )}
        <Button
          onClick={async () => {
            setIsLoading(true)
            await handleSubmit(skipNextTime)
            handleClose()
          }}
          disabled={isLoading}
        >
          {!isLoading ? t.cards.hide : <CircularProgress size={20} />}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

const HideCardAction = ({ funder, opportunityId, setShowDialog, loadData, dispatch }) => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const handleSubmit = async skipNextTime => {
    if (skipNextTime) localStorage.setItem(LS_HIDE, true)

    if (opportunityId) {
      await dispatch(markHidden(opportunityId))
    } else if (funder) {
      await dispatch(addToPipelineAndHide(funder.id))
    }
    await dispatch(loadData())
  }

  const handleHide = () => {
    const skip = localStorage[LS_HIDE] === 'true'

    if (skip) {
      setShowDialog(false)
      return handleSubmit()
    }

    setShowDialog(
      <HideDialog handleSubmit={handleSubmit} handleClose={() => setShowDialog(false)} />
    )
  }

  return (
    <MenuItem className="Material-cards__expanded-actions-item" onClick={handleHide}>
      {t.cards.hide}
    </MenuItem>
  )
}

export default HideCardAction
